"use client";

import { useSyncExternalStore } from "react";

let globalIsDomReady = false;
const listeners = new Set<() => void>();

if (typeof window !== "undefined") {
  const updateState = () => {
    if (globalIsDomReady) return;
    globalIsDomReady = true;
    listeners.forEach((l) => l());
  };
  if (document.readyState === "complete") {
    updateState();
  } else {
    window.addEventListener("load", updateState, { once: true });
  }
}

const subscribe = (onStoreChange: () => void) => {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
};

const getSnapshot = () => globalIsDomReady;

const getServerSnapshot = () => false;

export function useIsDomReady() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
